import { createValidatedFieldAtoms } from './formAtoms';
import {
  retryDelayAtom,
  retryDelayMultiplierAtom,
  retryNumberAtom,
  stepConditionAtom,
  stepIdAtom,
  stepIndexAtom,
  stepTitleAtom,
} from './stepFieldAtoms';

/**
 * Validated step field atoms
 * These atoms include validation rules and error state management for step properties
 */

export const validatedStepTitleAtom = createValidatedFieldAtoms<string>({
  valueAtom: stepTitleAtom,
});

export const validatedStepIdAtom = createValidatedFieldAtoms<string>({
  valueAtom: stepIdAtom,
});

export const validatedStepIndexAtom = createValidatedFieldAtoms<string>({
  valueAtom: stepIndexAtom,
});

export const validatedStepConditionAtom = createValidatedFieldAtoms<string>({
  valueAtom: stepConditionAtom,
});

export const validatedRetryNumberAtom = createValidatedFieldAtoms<number>({
  valueAtom: retryNumberAtom,
});

export const validatedRetryDelayAtom = createValidatedFieldAtoms<number>({
  valueAtom: retryDelayAtom,
});

export const validatedRetryDelayMultiplierAtom =
  createValidatedFieldAtoms<number>({
    valueAtom: retryDelayMultiplierAtom,
  });
